import ListingSection from "../ListingSection/ListingSection";
import fetchStateLocalities from "../SectionRegionElements/components/CountryStateSection/data/fetchStateLocalities";
import wrapperHOC from "@Utils/wrapperHOC";
import { useSelector, shallowEqual } from "react-redux";
import { AppState } from "@Store/index";
import useTranslationHook from "hooks/useTranslationHook";

const CitiesSectionWrapper = () => {
  const { t } = useTranslationHook();
  const { region, ssrCities } = useSelector(
    ({ searchPageData }: AppState) => ({
      region: searchPageData.region,
      ssrCities: searchPageData.listingData?.cities,
    }),
    shallowEqual,
  );

  return (
    <ListingSection
      title={`${t(
        "searchpage.components.sectionregionelements.components.countrystatesection.citiessectiontitle",
      )} ${region?.name}`}
      fetchFn={fetchStateLocalities}
      type="city"
      loadingText="Loading cities..."
      ssrData={ssrCities}
    />
  );
};

export default wrapperHOC(CitiesSectionWrapper, {
  componentName: "CitiesSection-SearchPage",
  showForChina: true,
});
